import { axiosInstance, parseResult } from "./CommonApi";

//화재수신기 검색
export const getFireFightingObject = async (serialNumber, dei) => {
  const params = { serialNumber: serialNumber, dei: dei };
  const response = await axiosInstance.get(
    `/fireon_main/firefighting-object/search/`,
    { params }
  );
  return parseResult(response);
};

//소방대상물 목록 조회
export const getFireFightingObjectList = async (
  filterType,
  filterValue,
  orderType
) => {
  const params = {
    filterType: filterType,
    filterValue: filterValue,
    orderType: orderType,
  };
  const response = await axiosInstance.get(
    `/fireon_main/firefighting-object/`,
    { params }
  );
  return parseResult(response);
};

//소방대상물 추가
export const createFireFightingObject = async (requestBody) => {
  const response = await axiosInstance.post(
    `/fireon_main/firefighting-object/create/`,
    requestBody,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};

//소방대상물 삭제(DB)
export const bulkDeleteFireFightingObjectDB = async (requestBody) => {
  const response = await axiosInstance.post(
    `/fireon_main/firefighting-object/bulk-delete-db/`,
    requestBody,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};

//소방대상물 삭제(USER)
export const bulkDeleteFireFightingObjectUser = async (requestBody) => {
  const response = await axiosInstance.post(
    `/fireon_main/firefighting-object/bulk-delete-user/`,
    requestBody,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};

//소방대상물 사용자 참여
export const joinFireFightingObject = async (id) => {
  const params = { id: id };
  const response = await axiosInstance.post(
    `/fireon_main/firefighting-object/${id}/join/`,
    {},
    { params }
  );
  return parseResult(response);
};

//소방대상물 조회
export const getFireFightingObjectById = async (id) => {
  const params = { id: id };
  const response = await axiosInstance.get(
    `/fireon_main/firefighting-object/${id}/`,
    params
  );
  return parseResult(response);
};

//소방대상물 수정
export const updateFireFightingObject = async (id, requestBody) => {
  const response = await axiosInstance.put(
    `/fireon_main/firefighting-object/${id}/update/`,
    requestBody,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};

//건물 상세 현황 조회
export const getBuildingDetail = async (id) => {
  const params = { id: id };
  const response = await axiosInstance.get(
    `/fireon_main/firefighting-object/building-detail/${id}/`,
    params
  );
  return parseResult(response);
};

//건물 상세 현황 업데이트
export const updateBuildingDetail = async (id, requestBody) => {
  const params = { id: id };
  const response = await axiosInstance.post(
    `/fireon_main/firefighting-object/building-detail/${id}/`,
    requestBody,
    {
      params: params,
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return parseResult(response);
};

//소방시설 일괄 삭제
export const bulkDeleteFireFightingFacility = async (requestBody) => {
  const response = await axiosInstance.post(
    `/fireon_main/firefighting-facility/bulk-delete/`,
    requestBody,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};

//소방시설 목록 조회 - 소방 설비 현황 화면
export const getFireFightingFacilityList = async (id, page, pageSize) => {
  const params = new URLSearchParams();
  params.append("id", id);
  if (page) {
    params.append("page", page);
  }
  if (pageSize) {
    params.append("page_size", pageSize);
  }

  const response = await axiosInstance.get(
    `/fireon_main/firefighting-facility/${id}/list/`,
    { params }
  );
  return parseResult(response);
};

export const getFireFightingFacilityListByUrl = async (url) => {
  const response = await axiosInstance.get(url);
  return parseResult(response);
};

//소방시설 추가
export const createFireFightingFacility = async (id, requestBody) => {
  const params = { id: id };
  const response = await axiosInstance.post(
    `/fireon_main/firefighting-facility/${id}/create/`,
    requestBody,
    {
      params: params,
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return parseResult(response);
};

//소방시설 조회
export const getFireFightingFacilityById = async (id) => {
  const params = { id: id };
  const response = await axiosInstance.get(
    `/fireon_main/firefighting-facility/${id}/`,
    params
  );
  return parseResult(response);
};

//사업자 리스트 조회
export const getBusinessUserList = async () => {
  const response = await axiosInstance.get(
    `/fireon_main/firefighting-object/users/business-list/`
  );
  return parseResult(response);
};

//소방대상물 사업자 설정
export const setFireFightingObjectBusinessUser = async (id, requestBody) => {
  const params = { id: id };
  const response = await axiosInstance.put(
    `/fireon_main/firefighting-object/users/${id}/set-business/`,
    requestBody,
    {
      params: params,
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};

//소방대상물 사업자 조회
export const getFireFightingObjectBusinessUser = async (id) => {
  const params = { id: id };
  const response = await axiosInstance.get(
    `/fireon_main/firefighting-object/users/${id}/get-business/`,
    params
  );
  return parseResult(response);
};

//소방설비 업데이트
export const updateFireFightingFacility = async (id, requestBody) => {
  const params = { id: id };
  const response = await axiosInstance.post(
    `/fireon_main/firefighting-facility/${id}/update`,
    requestBody,
    {
      params: params,
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return parseResult(response);
};

//소방대상물 권한 사용자 조회
export const getFireFightingObjectUsers = async (id) => {
  const params = { id: id };
  const response = await axiosInstance.get(
    `/fireon_main/firefighting-object/users/${id}/`,
    params
  );
  return parseResult(response);
};

//대표 관리자 설정
export const setFireFightingObjectUserPrimaryManager = async (id, userId) => {
  const params = { id: id, user_id: userId };
  const response = await axiosInstance.put(
    `/fireon_main/firefighting-object/users/${id}/set-primary-manager/`,
    {},
    { params }
  );
  return parseResult(response);
};

//접속 허용/차단 설정
export const setFireFightingObjectUserAccessPermission = async (
  id,
  userId,
  accessPermission
) => {
  const params = {
    id: id,
    user_id: userId,
    access_permission: accessPermission,
  };
  const response = await axiosInstance.put(
    `/fireon_main/firefighting-object/users/${id}/set-access-permission/`,
    {},
    { params }
  );
  return parseResult(response);
};

//알람 설정 조회
export const getFireFightingObjectAlarmSetting = async (id) => {
  const params = { id: id };
  const response = await axiosInstance.get(
    `/fireon_main/firefighting-object/alarm-setting/${id}/`,
    { params }
  );
  return parseResult(response);
};

//알람 설정 업데이트
export const updateFireFightingObjectAlarmSetting = async (id, requestBody) => {
  const params = { id: id };
  const response = await axiosInstance.put(
    `/fireon_main/firefighting-object/alarm-setting/${id}/`,
    requestBody,
    {
      params: params,
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};

//점검 일정 목록 조회
export const getFireFightingInspectionScheduleList = async (id) => {
  const params = { id: id };
  const response = await axiosInstance.get(
    `/fireon_main/firefighting-inspection-schedule/${id}/list/`,
    { params }
  );
  return parseResult(response);
};

//점검 일정 추가
export const createFireFightingInspectionSchedule = async (id, requestBody) => {
  const params = { id: id };
  const response = await axiosInstance.post(
    `/fireon_main/firefighting-inspection-schedule/${id}/create/`,
    requestBody,
    {
      params: params,
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};

//점검 일정 수정
export const updateFireFightingInspectionSchedule = async (id, requestBody) => {
  const params = { id: id };
  const response = await axiosInstance.put(
    `/fireon_main/firefighting-inspection-schedule/update/${id}`,
    requestBody,
    {
      params: params,
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};

//점검 일정 일괄 삭제
export const bulkDeleteFireFightingInspectionSchedule = async (requestBody) => {
  const response = await axiosInstance.post(
    `/fireon_main/firefighting-inspection-schedule/bulk-delete/`,
    requestBody,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};

//화재경보 발생이력 리스트 조회
export const getFireAlarmHistoryList = async (
  id,
  startDate,
  endDate,
  page,
  pageSize
) => {
  const params = new URLSearchParams();
  params.append("id", id);
  if (startDate) {
    params.append("startDate", startDate);
  }
  if (endDate) {
    params.append("endDate", endDate);
  }
  if (page) {
    params.append("page", page);
  }
  if (pageSize) {
    params.append("page_size", pageSize);
  }

  const response = await axiosInstance.get(
    `/fireon_main/fire-alarm-history/${id}/list`,
    { params }
  );
  return parseResult(response);
};

export const getFireAlarmHistoryListByUrl = async (url) => {
  const response = await axiosInstance.get(url);
  return parseResult(response);
};

//화재경보 발생이력 엑셀 다운로드
export const downloadExcelFireAlarmHistoryList = async (
  id,
  startDate,
  endDate
) => {
  const params = new URLSearchParams();
  params.append("id", id);
  if (startDate) {
    params.append("startDate", startDate);
  }
  if (endDate) {
    params.append("endDate", endDate);
  }

  const response = await axiosInstance.get(
    `/fireon_main/fire-alarm-history/${id}/excel-download`,
    {
      params: params,
      responseType: "blob",
    }
  );

  const result = parseResult(response);
  const { status, data } = result;
  if (status === true) {
    const url = window.URL.createObjectURL(
      new Blob([response.data], { type: response.headers["content-type"] })
    );
    const filename =
      response.headers["content-disposition"]?.split("filename=")[1];

    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  return result;
};

//화재경보 발생이력 조회
export const getFireAlarmHistory = async (id) => {
  const params = { id: id };
  const response = await axiosInstance.get(
    `/fireon_main/fire-alarm-history/${id}/`,
    { params }
  );
  return parseResult(response);
};

//화재경보 발생이력 수정
export const updateFireAlarmHistory = async (id, requestBody) => {
  const params = { id: id };
  const response = await axiosInstance.post(
    `/fireon_main/fire-alarm-history/${id}/update/`,
    requestBody,
    {
      params: params,
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return parseResult(response);
};

//화재구역1~5 수정
export const updateCircuitZones = async (id, requestBody) => {
  const params = { id: id };
  const response = await axiosInstance.post(
    `/fireon_main/firefighting-object/dashboard/update-circuit-zones/`,
    requestBody,
    {
      params: params,
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};

//화재경보 발생이력 일괄 삭제
export const bulkDeleteFireAlarmHistory = async (requestBody) => {
  const response = await axiosInstance.post(
    `/fireon_main/fire-alarm-history/bulk-delete/`,
    requestBody,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};

//소방대상물 제어
export const controlFireFightingObject = async (id, action, onoff) => {
  const params = { id: id, action: action, onoff: onoff };
  const response = await axiosInstance.post(
    `/fireon_main/firefighting-object/dashboard/control/`,
    {},
    { params }
  );
  return parseResult(response);
};

//화재수신기 동작 이력 조회
export const getFireFightingObjectActionList = async (id) => {
  const params = { id: id };
  const response = await axiosInstance.get(
    `/fireon_main/firefighting-object/dashboard/action-list/`,
    { params }
  );
  return parseResult(response);
};

//화재수신기 동작 이력 엑셀 다운로드
export const downloadExcelFireFightingObjectActionList = async (id) => {
  const params = { id: id };
  const response = await axiosInstance.get(
    `/fireon_main/firefighting-object/dashboard/action-list/download/`,
    {
      params: params,
      responseType: "blob",
    }
  );

  const result = parseResult(response);
  const { status, data } = result;
  if (status === true) {
    const url = window.URL.createObjectURL(
      new Blob([response.data], { type: response.headers["content-type"] })
    );
    const filename =
      response.headers["content-disposition"]?.split("filename=")[1];

    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  return result;
};

//LED 상태 조회
export const getFireFightingObjectLEDStatus = async (id) => {
  const params = { id: id };
  const response = await axiosInstance.get(
    `/fireon_main/firefighting-object/dashboard/led-status/`,
    { params }
  );
  return parseResult(response);
};

//건축물 현황 조회
export const getFireFightingObjectBuildingStatus = async (id) => {
  const params = { id: id };
  const response = await axiosInstance.get(
    `/fireon_main/firefighting-object/dashboard/building-status/${id}/`,
    { params }
  );
  return parseResult(response);
};

//전체 아이콘 리스트 조회
export const getBoundaryZoneMdbList = async () => {
  const response = await axiosInstance.get(
    `/fireon_main/firefighting-object/boundary-zone/mdb-list/`
  );
  return parseResult(response);
};

//경계구역일람도 설정 조회
export const getBoundaryZone = async (id, floor) => {
  const params = { id: id, floor: floor };
  const response = await axiosInstance.get(
    `/fireon_main/firefighting-object/boundary-zone/${id}/`,
    { params }
  );
  return parseResult(response);
};

//경계구역일람도 설정 저장
export const updateBoundaryZone = async (id, floor, requestBody) => {
  const params = { id: id, floor: floor };
  const response = await axiosInstance.post(
    `/fireon_main/firefighting-object/boundary-zone/${id}/`,
    requestBody,
    {
      params: params,
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return parseResult(response);
};

//화재알림 SMS 이력 리스트
export const getFireAlarmSmsHistoryList = async (
  id,
  startDate,
  endDate,
  receiverName,
  page,
  pageSize
) => {
  const params = new URLSearchParams();
  params.append("id", id);
  if (startDate) {
    params.append("startDate", startDate);
  }
  if (endDate) {
    params.append("endDate", endDate);
  }
  if (receiverName) {
    params.append("receiverName", receiverName);
  }
  if (page) {
    params.append("page", page);
  }
  if (pageSize) {
    params.append("page_size", pageSize);
  }
  const response = await axiosInstance.get(
    `/fireon_main/fire-alarm-sms-history/${id}/list/`,
    { params }
  );
  return parseResult(response);
};

export const getFireAlarmSmsHistoryListByUrl = async (url) => {
  const response = await axiosInstance.get(url);
  return parseResult(response);
};

//화재알림 SMS 이력 엑셀 다운로드
export const downloadExcelFireAlarmSmsHistoryList = async (
  id,
  startDate,
  endDate,
  receiverName,
  page,
  pageSize
) => {
  const params = new URLSearchParams();
  params.append("id", id);
  if (startDate) {
    params.append("startDate", startDate);
  }
  if (endDate) {
    params.append("endDate", endDate);
  }
  if (receiverName) {
    params.append("receiverName", receiverName);
  }
  if (page) {
    params.append("page", page);
  }
  if (pageSize) {
    params.append("page_size", pageSize);
  }
  const response = await axiosInstance.get(
    `/fireon_main/fire-alarm-sms-history/${id}/list/download/`,
    {
      params: params,
      responseType: "blob",
    }
  );

  const result = parseResult(response);
  const { status, data } = result;
  if (status === true) {
    const url = window.URL.createObjectURL(
      new Blob([response.data], { type: response.headers["content-type"] })
    );
    const filename =
      response.headers["content-disposition"]?.split("filename=")[1];

    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  return result;
};

//화재경보 통계표 조회
export const getFireAlarmStatistics = async (year) => {
  const params = { year: year };
  const response = await axiosInstance.get(
    `/fireon_main/firealarm-statistics/`,
    { params }
  );
  return parseResult(response);
};

//화재경보 통계표 엑셀 다운로드
export const downloadExcelFireAlarmStatistics = async (year) => {
  const params = { year: year };
  const response = await axiosInstance.get(
    `/fireon_main/firealarm-statistics/download/`,
    {
      params: params,
      responseType: "blob",
    }
  );

  const result = parseResult(response);
  const { status, data } = result;
  if (status === true) {
    const url = window.URL.createObjectURL(
      new Blob([response.data], { type: response.headers["content-type"] })
    );
    const filename =
      response.headers["content-disposition"]?.split("filename=")[1];

    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  return result;
};
